/**
 * Maps a value from one range to another.
 *
 * @param {number} input - the input value to be mapped
 * @param {number} min - the minimum value of the input range
 * @param {number} max - the maximum value of the input range
 * @param {number} newmin - the minimum value of the output range
 * @param {number} newmax - the maximum value of the output range
 * @return {number} the mapped value
 */
const lerp = (input: number, min: number, max: number, newmin: number, newmax: number): number => {
  return ((input - min) / (max - min)) * (newmax - newmin) + newmin;
};

const clamp = (input: number, min: number, max: number) => Math.min(max, Math.max(min, input));

export default {
  clamp,
  lerp,
};
